module.exports = __webpack_public_path__ + "static/media/icon_rick_2.d1557b5a.svg";